import React, { useState } from "react";
import regis_image from "../Assets/regis_image.png";
import { FaEye, FaEyeSlash, FaLock, FaUser } from "react-icons/fa";
import { SignInMethod, signInWithPopup } from "firebase/auth";
import { auth, provider } from "../firebase.js";
import { IoMdCloseCircleOutline } from "react-icons/io";
import "../Style/Register.css";
import { FcGoogle } from "react-icons/fc";
import { loginUser } from "../backend.js"; // Import API function
import { useAuth } from "./UserContext.js";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const {
    currentUser,
    isLoggedIn,
    login,
    setUser,
    setShowLoginComponent,
    setShowRegisterComponent,
  } = useAuth();
  const isMobile = window.innerWidth <= 768;
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  // Handle input change
  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const googleLogin = async () => {
    const e = null;
    signInWithPopup(auth, provider)
      .then(async (result) => {
        setCredentials((prevCredentials) => ({
          ...prevCredentials,
          email: result.user.email,
        }));

        // Call handleSubmit after state update
        handleSubmit(null, result.user.email);
      })
      .catch((error) => {
        console.error("Google Sign-In Error:", error);
        alert("Google login failed. Please try again.");
      });
  };
  // Handle form submission
  const handleSubmit = async (e, email) => {
    if (e) e.preventDefault();
    try {
      const userCredentials = {
        ...credentials,
        email: email || credentials.email,
      };

      const { token, user } = await loginUser(userCredentials);
      console.log("Login token",token)
      localStorage.setItem("token", token);
      login(token);
      alert(`Welcome ${user.firstName}!`);
      setShowLoginComponent(false);
      navigate("/");
    } catch (error) {
      alert(error.message || "Please forgot password and try again.");
    }
  };

  return (
    <div className="register-container" onClick={(e) => e.stopPropagation()}>
      <div className="form-section">
        <h1 className="form-heading-h1">LOGIN</h1>
        <p className="form-p1">
          Welcome to HOMOEOPATHIC HEALTH CARE & RESEARCH CENTER
        </p>
        <form onSubmit={handleSubmit}>
          <div
            className="input-container"
            style={{
              width: isMobile ? "90%" : "60%",
              margin: "auto",
              marginTop: "30px",
            }}
          >
            <FaUser />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={credentials.email}
              onChange={handleChange}
              required
            />
          </div>
          <div
            className="input-container"
            style={{
              width: isMobile ? "90%" : "60%",
              margin: "auto",
              marginTop: "20px",
            }}
          >
            <FaLock />
            <input
              type={passwordVisible ? "text" : "password"}
              name="password"
              placeholder="Password"
              value={credentials.password}
              onChange={handleChange}
              required
            />
            <span
              className="toggle-password"
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              {passwordVisible ? (
                <FaEyeSlash size={23} color="var(--primary-color)" />
              ) : (
                <FaEye size={23} color="var(--primary-color)" />
              )}
            </span>
          </div>
          <div className="forgot-login">
            <Link
              to={"/forgotpassword"}
              onClick={() => {
                setShowLoginComponent(false);
              }}
            >
              Forgot Password ?
            </Link>
          </div>
          <div
            style={{
              width: isMobile ? "60%" : "25%",
              margin: "auto",
              marginTop: "20px",
            }}
          >
            <button
              type="submit"
              className="create-account-btn"
              style={{ fontSize: "16px" }}
            >
              Login Now
            </button>
          </div>
          <p className="login-link" style={{ width: "100%" }}>
            Don't have an account?
            <span
              onClick={() => {
                setShowLoginComponent(false);
                setShowRegisterComponent(true);
              }}
            >
              Register
            </span>
          </p>
          <div
            style={{
              display: "flex",
              width: isMobile ? "100%" : "80%",
              margin: "auto",
              alignItems: "center",
            }}
          >
            <div className="border-line-regis"></div>
            <p
              className="or"
              style={{
                fontSize: isMobile ? "13px" : "20px",
                marginTop: "28px",
              }}
            >
              <span style={{ color: "black", fontWeight: "600" }}>Login</span>{" "}
              with others
            </p>
            <div className="border-line-regis"></div>
          </div>
          <div className="login-google" onClick={googleLogin}>
            <FcGoogle size={35} />
            <p className="google-btn">Login with Google</p>
          </div>
          {/* <div className="login-google">
            <FaSquareFacebook size={35} color="#4267B2" />
            <p className="facebook-btn">Login with Facebook</p>
          </div> */}
        </form>
      </div>
      {!isMobile ? (
        <div className="image-section">
          <img src={regis_image} alt="Doctor and patient" />
        </div>
      ) : (
        ""
      )}
      <div className="close-icon" onClick={() => setShowLoginComponent(false)}>
        <IoMdCloseCircleOutline size={50} color="var(--tertiary)" />
      </div>
    </div>
  );
};

export default Login;
